module.exports = __webpack_public_path__ + "static/7-formation-deformation-s-x-78c062d0744bcf66e735634d0becb0dd.jpg";